"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const themes_1 = require("../../../themes");
const container = {
    display: 'grid',
    alignSelf: 'start',
    justifyItems: { xs: 'center', md: 'start' },
    rowGap: themes_1.Spacings.small2,
};
const label = {
    color: 'grey.100',
    fontSize: 18,
    fontWeight: '900',
    whiteSpace: { md: 'pre-line' },
};
const copyright = {
    color: 'common.white',
    opacity: 0.4,
    fontSize: 12,
};
exports.default = {
    container,
    label,
    copyright,
};
